import * as ResidentialForRent from "./ResidentialForRent/index.js";
import * as ForSale from "./ForSale/index.js";
import * as OnePageReport from "./OnePageReport/index.js";
import * as AppleWatch from "./AppleWatch/index.js";
import * as AssessmentSearch from "./AssessmentSearch/index.js";
import * as Data from "./Data/index.js";
import * as SaleComps from "./SaleComps/index.js";
import * as AssessmentUnitedKingdom from "./AssessmentUnitedKingdom/index.js";
import * as Closest from "./Closest/index.js";
import * as Nearby from "./Nearby/index.js";
import * as Tenants from "./Tenants/index.js";
/** CoStar.Api.EnterpriseSub2.Detail.MeasurementConversion */
export var MeasurementConversion;
(function (MeasurementConversion) {
    MeasurementConversion[MeasurementConversion["None"] = 0] = "None";
    MeasurementConversion[MeasurementConversion["Metric"] = 1] = "Metric";
    MeasurementConversion[MeasurementConversion["Customary"] = 2] = "Customary";
})(MeasurementConversion || (MeasurementConversion = {}));
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.EnterpriseSub2.Detail.AreaMeasure */
export { AreaMeasure };
/** CoStar.Api.EnterpriseSub2.Detail.DemographicRadiusIndex */
export var DemographicRadiusIndex;
(function (DemographicRadiusIndex) {
    DemographicRadiusIndex[DemographicRadiusIndex["Unknown"] = 0] = "Unknown";
    DemographicRadiusIndex[DemographicRadiusIndex["Radius1Index"] = 1] = "Radius1Index";
    DemographicRadiusIndex[DemographicRadiusIndex["Radius2Index"] = 2] = "Radius2Index";
    DemographicRadiusIndex[DemographicRadiusIndex["Radius3Index"] = 3] = "Radius3Index";
    DemographicRadiusIndex[DemographicRadiusIndex["Radius4Index"] = 4] = "Radius4Index";
    DemographicRadiusIndex[DemographicRadiusIndex["Radius5Index"] = 5] = "Radius5Index";
})(DemographicRadiusIndex || (DemographicRadiusIndex = {}));
import { SortOrder } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Detail.SortOrder */
export { SortOrder };
/** CoStar.Api.EnterpriseSub2.Detail.PropertyGroupType */
export var PropertyGroupType;
(function (PropertyGroupType) {
    PropertyGroupType[PropertyGroupType["None"] = 0] = "None";
    PropertyGroupType[PropertyGroupType["ShoppingCenter"] = 1] = "ShoppingCenter";
    PropertyGroupType[PropertyGroupType["IndustrialPark"] = 2] = "IndustrialPark";
    PropertyGroupType[PropertyGroupType["OfficePark"] = 3] = "OfficePark";
    PropertyGroupType[PropertyGroupType["MixedUse"] = 4] = "MixedUse";
})(PropertyGroupType || (PropertyGroupType = {}));
/** CoStar.Api.EnterpriseSub2.Detail.PropertyGroupSubtype */
export var PropertyGroupSubtype;
(function (PropertyGroupSubtype) {
    PropertyGroupSubtype[PropertyGroupSubtype["None"] = 0] = "None";
    PropertyGroupSubtype[PropertyGroupSubtype["AirportRetail"] = 1] = "AirportRetail";
    PropertyGroupSubtype[PropertyGroupSubtype["CommunityCenter"] = 2] = "CommunityCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["LifestyleCenter"] = 3] = "LifestyleCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["NeighborhoodCenter"] = 4] = "NeighborhoodCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["OutletCenter"] = 5] = "OutletCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["PowerCenter"] = 6] = "PowerCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["RegionalMall"] = 7] = "RegionalMall";
    PropertyGroupSubtype[PropertyGroupSubtype["FestivalCenter"] = 8] = "FestivalCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["StripCenter"] = 9] = "StripCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["SuperregionalMall"] = 10] = "SuperregionalMall";
    PropertyGroupSubtype[PropertyGroupSubtype["RegionalPrime"] = 11] = "RegionalPrime";
    PropertyGroupSubtype[PropertyGroupSubtype["MajorUrbanCentre"] = 12] = "MajorUrbanCentre";
    PropertyGroupSubtype[PropertyGroupSubtype["UrbanCentre"] = 13] = "UrbanCentre";
    PropertyGroupSubtype[PropertyGroupSubtype["District"] = 14] = "District";
    PropertyGroupSubtype[PropertyGroupSubtype["SolusUnit"] = 15] = "SolusUnit";
    PropertyGroupSubtype[PropertyGroupSubtype["ShoppingPark"] = 16] = "ShoppingPark";
    PropertyGroupSubtype[PropertyGroupSubtype["RetailPark"] = 17] = "RetailPark";
    PropertyGroupSubtype[PropertyGroupSubtype["LeisurePark"] = 18] = "LeisurePark";
})(PropertyGroupSubtype || (PropertyGroupSubtype = {}));
/** CoStar.Api.EnterpriseSub2.Detail.TransitType */
export var TransitType;
(function (TransitType) {
    TransitType[TransitType["Unknown"] = 0] = "Unknown";
    TransitType[TransitType["Airport"] = 1] = "Airport";
    TransitType[TransitType["CommuterRailStation"] = 2] = "CommuterRailStation";
    TransitType[TransitType["TransitStation"] = 3] = "TransitStation";
    TransitType[TransitType["Seaport"] = 4] = "Seaport";
})(TransitType || (TransitType = {}));
export { ResidentialForRent, ForSale, OnePageReport, AppleWatch, AssessmentSearch, Data, SaleComps, AssessmentUnitedKingdom, Closest, Nearby, Tenants };
